import { Modal } from 'antd';
import deleteProject from '../Services/deleteProject';

const { confirm } = Modal;

export default () => async (dispatch) => {

  confirm({
    title: `Are you sure you want to delete this Project?`,
    content: 'Note: This action cannot be undone',
    okText: 'Yes, Delete it',
    onOk() {
      
      dispatch(deleteProject());
      
    }
  });

}